import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientEvolutions () {
    return Api().get("/patient-evolutions");
  },
  updatePatientEvolution (params) {
    return Api().put("/patient-evolutions",params);
  },
  addPatientEvolution (params) {
    return Api().post("/patient-evolutions",params);
  },
  getPatientEvolution (params) {
    return Api().get("/patient-evolutions/"+params);
  },
  getPatientEvolutionByPatient (params) {
    return Api().get("/patient-evolutions-by-patient/"+params);
  },
  deletePatientEvolution (params) {
    return Api().delete("/patient-evolutions/"+params);
  },
  getPatientEvolutionByRouteSheets(params){
    return Api().get("/patient-evolutions-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientEvolutionService.js